import { useMutation } from "@apollo/client";
import { LOGS_USER_REPORT } from "graphql/mutation/log-gql";
import { successNotification, errorNotification } from "components/request-result";
import { saveAs } from "file-saver";


const useMutationUserReport = () => {

    function getFileNameFromUrl(url) {
        const value = url.split('/');
        return value[ value.length - 1 ];
    }

    const [ _setUserReport, { loading } ] = useMutation(LOGS_USER_REPORT,
        {
            update(cache, { data }) {

                const {
                    logsUserReportExel: {
                        label,
                        message,
                        file
                    }
                } = data;

                successNotification({
                    title: label,
                    description: message
                })


                saveAs(file, getFileNameFromUrl(file));
            },


            onError(error) {
                errorNotification(error);
            },

        }
    );


    return {
        _setUserReport,
        loadingMutationUserReport: loading,
    }
};


export default useMutationUserReport;

